module.exports = __webpack_public_path__ + "static/media/calendar-exclamation.2a169fd5.svg";